import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import Chat from "@material-ui/icons/Chat";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import Security from "@material-ui/icons/Security";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

class ProductSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h1 className={classes.title}>Let's talk Product</h1>
            <h2 className={classes.title} style={{
              paddingTop: '10px'
            }}>Smpl TRACE</h2>
            <h4 className={classes.description} style={{
              paddingTop: '10px',
              paddingBottom: '40px'
            }}>
            Smpl TRACE is a blockchain-based turnkey platform that provides 
            end-to-end tracking and tracing of industrial hemp. 
            </h4>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Immutable"
                description="By providing an immutable record (what we call a digital fingerprint) for crops and products, TRACE can establish the legitimacy of farming and processing operations that are enrolled on the platform."
                icon={Chat}
                iconColor="info"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Verifiable and Transparent Data"
                description="The information is contained on a Distributed Ledger, or Blockchain, that is maintained by Smpl. When a product is produced, processed, or transported, it is recorded on the ledger, this allows a high degree of transparency and verifiability."
                icon={VerifiedUser}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Secure"
                description="Allows seed producers, farmers, and processors to prove the legitimacy of their operations, plants, and products to regulators and customers. All a TRACE user has to do is provide their account ID via the desktop or mobile application, this is linked directly to the digital fingerprint of all seeds, plants, or products that are currently owned by the user."
                icon={Security}
                iconColor="danger"
                vertical
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);
